import { Wrapper } from './wrapper';
import { List } from './list';
import { Panel } from './panel';

export const Tabs = {
	Wrapper,
	List,
	Panel
};
